import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../../boot";
import axios from "axios";

// get customers

export const getPriceListApi = createAsyncThunk("client/get-productPrice-list", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}admin/productPrice/api/v1/get-productPrice-list`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });

    console.log("response of getPriceListApi list", response);
    return response;
  } catch (error) {
    console.error("Error fetching getPriceListApi - ", error);
    throw error;
  }
});

export const ImportPriceListApi = createAsyncThunk("/import-csv-files", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}import-csv-router/api/v2/import-csv-files`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });

    console.log("response of price import list", response);
    return response.data;
  } catch (error) {
    console.error("Error fetching customers - ", error);
    throw error;
  }
});

// get conut
export const getPriceListCountApi = createAsyncThunk("client/productPrice-count", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}admin/productPrice/api/v1/productPrice-count`, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });

    console.log("response of getPriceListCountApi list", response);
    return response;
  } catch (error) {
    console.error("Error fetching getPriceListCountApi - ", error);
    throw error;
  }
});

// update price lsit
export const updatePriceListApi = createAsyncThunk("client/update-productPrice-list", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.put(`${baseUrl}admin/productPrice/api/v1/update-productPrice/${data.ROWID}`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });

    console.log("response of getPriceListApi list", response);
    return response;
  } catch (error) {
    console.error("Error fetching getPriceListApi - ", error);
    throw error;
  }
});

// delete price list
export const deletePriceListApi = createAsyncThunk("client/delete-productPrice-list", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.delete(`${baseUrl}admin/productPrice/api/v1/delete-productPrice/${data}`, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });

    console.log("response of getPriceListApi list", response);
    return response;
  } catch (error) {
    console.error("Error fetching getPriceListApi - ", error);
    throw error;
  }
});

// create price list
export const createPriceListApi = createAsyncThunk("client/create-productPrice", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}admin/productPrice/api/v1/create-productPrice`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });

    console.log("response of getPriceListApi list", response);
    return response;
  } catch (error) {
    console.error("Error fetching getPriceListApi - ", error);
    throw error;
  }
});
